module.exports = "data:image/png;base64,R0lGODlhAQABAIABAEhISP///yH+EUNyZWF0ZWQgd2l0aCBHSU1QACwAAAAAAQABAAACAkQBADs="